export default "__VITE_ASSET__B74$jlLD__"